/**
 * eslint-disable @typescript-eslint/no-unused-vars
 *
 * @format
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
/** @format */

import { ViewportScroller } from '@angular/common';
import { Component, HostListener, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDate, NgbDatepickerI18n, NgbDateStruct, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { blankConfiguration, Configuration, ManageProfile, Profile } from 'src/app/models/profile';
import {
	getAllUserTimesheets,
	getDirectEmployeeTimesheets,
	getEmployeeTimesheets,
	getExceptionTypes,
	getPayPeriods,
	getProfile,
	getTeamProfile,
	getTimesheets,
} from 'src/app/store';
import {
	ApplicationState,
	ApproveTimesheets,
	CalendarMonthlyEntry,
	ClearTeamProfile,
	ExceptionType,
	GetApprovedTimesheets,
	GetEmployeeTimesheets,
	GetTeamProfilePicsBulk,
	ManagerEmployeeTimesheetView,
	NotificationStates,
	PayPeriod,
	PostTimesheet,
	SubmitTimesheet,
	TeamMemberProfile,
	Timesheet,
	TimesheetApprovalSubmission,
	TimesheetEntryType,
	TimesheetExceptionType,
	ToastUserNotification,
	UserNotification,
	UserTimesheet,
} from 'src/app/store/application';
import * as HelperFunctions from 'src/assets/helper-functions/helper-functions';
import { TimesheetComponent } from '../timesheet/timesheet.component';
import { roles } from 'src/app/app.module';
import { MsalService } from '@azure/msal-angular';

@Component({
	selector: 'app-approvals',
	templateUrl: './approvals.component.html',
	styleUrls: ['./approvals.component.scss'],
	standalone: false,
})
export class ApprovalsComponent implements OnInit, OnChanges, OnDestroy {
	private ngUnsubscribe: Subject<void> = new Subject();

	calendarEntries$: Observable<CalendarMonthlyEntry[]> | undefined;
	calendarEntries: CalendarMonthlyEntry[] = [];

	allUserTimesheets$: Observable<UserTimesheet[]>;
	allUserTimesheets: UserTimesheet[] = [];

	employeeTimesheets$: Observable<ManagerEmployeeTimesheetView[]> | undefined;
	employeeTimesheets: ManagerEmployeeTimesheetView[] = [];
	filteredTimesheets: ManagerEmployeeTimesheetView[] = [];
	timeEntryTypes: TimesheetExceptionType[];

	timesheets$: Observable<Timesheet[]>;
	timesheets: Timesheet[] = [];

	teamProfile$: Observable<TeamMemberProfile[]> | undefined;
	teamProfile: TeamMemberProfile[] = [];
	teamProfileFiltered: TeamMemberProfile[] = [];

	profile$: Observable<Profile>;
	profile!: Profile;

	role: any = [];

	timekeeperView = false;
	isTimekeeperAndManager = false;

	payPeriods$: Observable<PayPeriod[]>;
	payPeriods!: PayPeriod[];

	exceptionTypes$!: Observable<ExceptionType[]>;
	exceptionTypes!: ExceptionType[];

	model: NgbDateStruct | undefined;
	fromDate: NgbDate | undefined;
	toDate: NgbDate | undefined;
	quickSelect = 'none';

	selectedUserConfiguration: Configuration = blankConfiguration;
	currentSelectedConfigurations: Configuration[] = [];

	minDate = new NgbDate(2022, 1, 1);
	dpForm: UntypedFormGroup = new UntypedFormGroup({
		weekRange: new UntypedFormControl(''),
	});

	selectForm: UntypedFormGroup;
	teamForm: UntypedFormGroup;
	selectedEmployees: any = [];
	emailsMap: { [id: string]: string } = {};
	emailDateMap: { [id: string]: { email: string; week: string; startDate: Date } } = {};
	currentWeekStr = '';
	currentWeek: { startDate: Date; endDate: Date } = { startDate: new Date(), endDate: new Date() };
	payperiodWeek = '';
	// month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	isApprovals = false;
	submittedTimesheets: TeamMemberProfile[] = [];

	timesheetJustApproved = false;
	isShowingMultipleTimesheets = false;
	deadlineDate = new Date();
	directEmployeTimesheets$: Observable<ManagerEmployeeTimesheetView[]>;
	approvalWeeks: { [id: number]: { email: string; week: string; startDate: Date }[] } = [];
	sortedApprovalKeys: number[] = [];
	sortedByWeek: { startDate: Date; user: string[] }[] = [];
	Object = Object;
	pageYoffset: number | undefined;
	filterBy = '';
	statusCount = {
		submitted: 0,
		invalid: 0,
		pending: 0,
		approved: 0,
		jde: 0,
	};

	payPeriodLookupInterval: any;

	approvalLockedTimesheets: Timesheet[] = [];
	bulkApproveHasInvalidTimesheets = false;
	approvalErrorTimesheets: Timesheet[] = [];

	allManagedUsers: ManageProfile[] = [];
	managerUsers: ManageProfile[] = [];
	timekeeperUsers: ManageProfile[] = [];

	@HostListener('window:scroll')
	onScroll() {
		this.pageYoffset = window.pageYOffset;
	}

	constructor(
		private store: Store<ApplicationState>,
		private calendar: NgbCalendar,
		public i18n: NgbDatepickerI18n,
		private formBuilder: UntypedFormBuilder,
		public router: Router,
		private scroll: ViewportScroller,
		private modalService: NgbModal,
		private msalService: MsalService
	) {
		this.employeeTimesheets$ = this.store.select(getEmployeeTimesheets);
		this.allUserTimesheets$ = this.store.select(getAllUserTimesheets);
		this.timesheets$ = this.store.select(getTimesheets);
		this.teamProfile$ = this.store.select(getTeamProfile);
		this.profile$ = this.store.select(getProfile);
		this.selectForm = this.formBuilder.group({
			apprEmps: this.formBuilder.array([]),
		});
		this.teamForm = this.formBuilder.group({
			employees: new UntypedFormControl(''),
		});

		this.timeEntryTypes = HelperFunctions.getTimesheetExceptionTypes();
		this.directEmployeTimesheets$ = this.store.select(getDirectEmployeeTimesheets);
		this.exceptionTypes$ = this.store.select(getExceptionTypes);
		this.payPeriods$ = this.store.select(getPayPeriods);
	}

	get appArr() {
		return this.selectForm.get('apprEmps') as UntypedFormArray;
	}

	ngOnInit(): void {
		if (this.router.url.toLowerCase().indexOf('approvals') > -1) {
			this.isApprovals = true;
			this.payperiodWeek = '';
			this.selectedEmployees = [];
		}

		this.profile$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((profile) => {
			this.profile = profile;
			this.getRoleFromMsal();

			if (this.role.includes(roles.Manager)) this.timekeeperView = false;
			if (this.role.includes(roles.TimeKeepers)) this.timekeeperView = true;
			if (this.role.includes(roles.Manager) && this.role.includes(roles.TimeKeepers)) this.isTimekeeperAndManager = true;

			// NOTE: Developer states to be set for testing this page
			// this.timekeeperView = true;
			// this.isTimekeeperAndManager = true;

			this.store.dispatch(GetApprovedTimesheets({ isManagerView: !this.timekeeperView }));
			this.store.dispatch(GetEmployeeTimesheets());
		});

		this.allUserTimesheets$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((timesheets) => {
			this.allUserTimesheets = timesheets;
			this.timekeeperUsers = [...this.profile.timekeeperDelegated, ...this.profile.timekeeperManagedUsers];
			this.managerUsers = [...this.profile.manage, ...this.profile.delegated, ...this.profile.managedGoneFromDNV];

			if (this.timekeeperView && !this.isTimekeeperAndManager) {
				// user is a timekeeper
				this.allManagedUsers = [...this.timekeeperUsers];
				const timesheetManagedUsersIds = this.allManagedUsers.map((u) => u.user.id);

				this.employeeTimesheets = timesheets.filter(
					(ts) => ts.timekeeperId === this.profile.user.id || timesheetManagedUsersIds.includes(ts.userId)
				);
			} else if (!this.timekeeperView && !this.isTimekeeperAndManager) {
				// user is a manager
				this.allManagedUsers = [...this.managerUsers];
				const timesheetUserIds = timesheets.map((ts) => ts.userId);
				const managedUserIds = this.allManagedUsers.map((profile) => profile.user.id);

				const filteredTimesheetUsers = timesheetUserIds.filter((tsUserId) => managedUserIds.includes(tsUserId));
				this.employeeTimesheets = timesheets.filter((ts) => filteredTimesheetUsers.includes(ts.userId));
			} else {
				// user is both a manager and timekeeper
				this.allManagedUsers = [...this.timekeeperUsers];
				this.managerUsers.forEach((mu) => {
					const alreadyInList = this.allManagedUsers.some((amu) => amu.user.id === mu.user.id);
					if (!alreadyInList) {
						this.allManagedUsers.push(mu);
					}
				});

				const timesheetUserIds = timesheets.map((ts) => ts.userId);
				const userIds = this.allManagedUsers.map((profile) => profile.user.id);
				const filteredTimesheetUsers = timesheetUserIds.filter((tsUserId) => userIds.includes(tsUserId));
				this.employeeTimesheets = timesheets.filter((ts) => filteredTimesheetUsers.includes(ts.userId));
			}

			const upns: string[] = this.employeeTimesheets.map((timesheet) => timesheet.employeeEmail);
			this.store.dispatch(GetTeamProfilePicsBulk({ upns }));
		});

		this.timesheets$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((timesheets) => {
			this.timesheets = timesheets;
			if (this.timesheets.length > 0 && this.currentWeekStr.length === 0) {
				const today = new Date();
				const thisWk = this.timesheets.filter((t) => HelperFunctions.getDateIsWithinBounds(t.startDate, t.endDate, today));

				if (thisWk.length > 0) {
					const startDate = new Date(thisWk[0].startDate);
					const endDate = new Date(thisWk[0].endDate);
					const ngbStart = this.dateToNgbDate(startDate); //new NgbDate(startDate.getFullYear(), startDate.getMonth() + 1, startDate.getDate());
					const ngbEnd = this.dateToNgbDate(endDate); // new NgbDate(endDate.getFullYear(), endDate.getMonth() + 1, endDate.getDate());
					this.currentWeek = { startDate, endDate };
					this.currentWeekStr = this.dateToString(ngbStart, ngbEnd);
					this.fromDate = ngbStart;
					this.toDate = ngbEnd;
					this.dpForm.get('weekRange')?.setValue(this.currentWeekStr);
					this.deadlineDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() - 1);

					if (!this.isApprovals) {
						if (this.payPeriods && this.payPeriods.length > 0) {
							this.payperiodWeek = HelperFunctions.getTimesheetPayPeriodInfo(thisWk[0], this.payPeriods);
						} else {
							this.payPeriodLookupInterval = setInterval(() => {
								if (this.payPeriods.length > 0) {
									clearInterval(this.payPeriodLookupInterval);
									this.payperiodWeek = HelperFunctions.getTimesheetPayPeriodInfo(thisWk[0], this.payPeriods);
								}
							}, 100);
						}
					}
				}
			}
		});

		this.model = this.calendar.getToday();

		this.employeeTimesheets$?.pipe(takeUntil(this.ngUnsubscribe)).subscribe((employeeTimesheets) => {
			if (!this.timekeeperView) {
				const managedUsers = [...this.profile.manage, ...this.profile.delegated, ...this.profile.managedGoneFromDNV];
				const upns = [];
				if (employeeTimesheets.length > 0) {
					for (const em of employeeTimesheets) {
						const profile = managedUsers.filter((tm) => HelperFunctions.compareEmail(tm.user.email, em.employeeEmail));
						if (profile.length > 0) {
							upns.push(profile[0].user.upn);
						}
					}
					if (upns.length > 0) {
						this.store.dispatch(GetTeamProfilePicsBulk({ upns }));
					}
				}

				this.employeeTimesheets = employeeTimesheets;
				this.filteredTimesheets = this.filterTimesheets();
				this.updateApproveAllLockStatus();
				this.updateStatus();
			}
		});

		this.teamProfile$?.pipe(takeUntil(this.ngUnsubscribe)).subscribe((team) => {
			// prevent Team page from sometimes getting stuck showing all employees in the db
			const currentTeamEmails = this.employeeTimesheets.map((timesheet) => timesheet.employeeEmail);
			const incomingTeamEmails = team.map((profile) => profile.email);
			if (
				!this.timekeeperView &&
				(currentTeamEmails.length !== incomingTeamEmails.length ||
					!currentTeamEmails.every((email, index) => email === incomingTeamEmails[index]))
			) {
				return;
			}

			this.teamProfile = team.slice().sort((a, b) => this.getTeamMemberName(a.email).localeCompare(this.getTeamMemberName(b.email)));
			this.teamProfileFiltered = [...this.teamProfile];

			for (let i = 0; i < team.length; i++) {
				const em = this.employeeTimesheets.filter((e) => HelperFunctions.compareEmail(e.employeeEmail, team[i].email));
				if (em.length > 0) {
					const wk = em[0].timesheets.filter((t) => {
						const sd = new Date(t.startDate);
						const ed = new Date(t.endDate);
						const ngbStart = this.dateToNgbDate(sd);
						const ngbEnd = this.dateToNgbDate(ed);
						if (ngbStart.equals(this.fromDate) && ngbEnd.equals(this.toDate)) {
							return t;
						}
						return null;
					});

					if (!this.isApprovals) {
						if (wk.length > 0) {
							const isTimesheetInvalid = this.getTimesheetIsInvalid(wk[0]);
							this.setStatus(em[0].employeeEmail, isTimesheetInvalid ? 'invalid' : wk[0].status);
						} else {
							this.setStatus(em[0].employeeEmail, 'saved');
						}
					}
				}

				if (!this.isApprovals) {
					this.emailsMap[i] = team[i].email;
				}
			}
			this.filteredTimesheets = this.filterTimesheets();
			this.updateApproveAllLockStatus();

			// do status counts
			this.updateStatusCounts();
		});

		// construct new object for 'approvals' page grouped by dates
		this.directEmployeTimesheets$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((ts) => {
			if (this.isApprovals === true) {
				this.approvalWeeks = [];
				this.sortedApprovalKeys = [];
				ts.forEach((employee) => {
					const submitted = employee.timesheets.filter((t) => t.status.toLowerCase() === 'submitted');
					if (submitted.length > 0) {
						const cloneObj = Object.assign({}, submitted);

						// console.log(employee.employeeEmail, cloneObj);

						for (const co of Object.keys(cloneObj)) {
							const ts = cloneObj[co as any];
							// console.log(co, ts);
							const tempDate = this.dateToString(this.dateToNgbDate(ts.startDate), this.dateToNgbDate(ts.endDate));
							const tempKey = ts.startDate.getTime(); // for sorting
							if (!this.approvalWeeks.hasOwnProperty(tempKey)) {
								this.sortedApprovalKeys.push(tempKey);
								this.approvalWeeks[tempKey] = [];
								this.approvalWeeks[tempKey as any].push({ email: employee.employeeEmail, week: tempDate, startDate: ts.startDate });
							} else {
								const tempObj = this.approvalWeeks[tempKey as any].filter(
									(o: { email: string }) => o.email === employee.employeeEmail
								);
								if (tempObj.length === 0) {
									this.approvalWeeks[tempKey as any].push({
										email: employee.employeeEmail,
										week: tempDate,
										startDate: ts.startDate,
									});
								}
							}
						}
						// console.log(this.approvalWeeks);
					}
				});

				this.sortedApprovalKeys = this.sortedApprovalKeys.sort((x: any, y: any) => x - y);
				// create emailDateMap in date order
				let mapIdx = 0;
				// this.selectedEmployees = [];
				this.sortedApprovalKeys.forEach((key: number) => {
					this.approvalWeeks[key].forEach((user: any) => {
						this.emailDateMap[mapIdx] = user;
						mapIdx++;
					});
				});
				// console.log('email date: ', this.emailDateMap);
				// add controls
				this.appArr.clear();
				this.sortedApprovalKeys.forEach((key) => {
					const submissions = this.approvalWeeks[key];

					for (let i = 0; i < submissions.length; i++) {
						// console.log(i, this.approvalWeeks[key][i]);
						const employee = submissions[i];

						const isSelectedEmployee = this.selectedEmployees.some(
							(emp: any) =>
								emp.employeeEmail === employee.email &&
								emp.startDates.some((startDate: Date) => startDate.getTime() === employee.startDate.getTime())
						);

						const fg = this.formBuilder.group({
							chkbox: isSelectedEmployee,
						});

						this.appArr.push(fg);
					}
				});

				this.filteredTimesheets = this.filterTimesheets();
				this.updateApproveAllLockStatus();
			}
		});

		this.exceptionTypes$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((e) => {
			this.exceptionTypes = e;
		});

		this.payPeriods$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((payPeriods) => {
			this.payPeriods = payPeriods;
		});
	}

	ngOnChanges(change: SimpleChanges): void {
		console.log(change);
	}

	ngOnDestroy() {
		this.ngUnsubscribe.next();
		this.ngUnsubscribe.unsubscribe();
	}

	getRoleFromMsal(): void {
		if (this.msalService.instance && this.msalService.instance.getAllAccounts().length > 0) {
			let account = this.msalService.instance.getAllAccounts()[0];
			if (account.authorityType === 'MSSTS') {
				if (
					account.idTokenClaims &&
					account.idTokenClaims.roles &&
					account.idTokenClaims.preferred_username?.toLowerCase() === this.profile.user.upn.toLowerCase()
				) {
					this.role.push(...account.idTokenClaims.roles);
				}
			}
		}
	}

	getWeekOneTsHasUsedCdo(timesheet: Timesheet, userEmail: string) {
		const user = this.filteredTimesheets.find((u) => u.employeeEmail === userEmail)!;
		const userTimesheets = user.timesheets;
		const timesheetPairs = userTimesheets
			.filter((ts) => ts.payPeriod === timesheet.payPeriod)
			.sort((a: Timesheet, b: Timesheet) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());

		// find the sibling timesheet for the one that we are looking at currently
		const siblingTsIndex = timesheetPairs.findIndex((ts) => ts.id !== timesheet.id)!;
		const isSiblingWeekOneTs = siblingTsIndex === 1;

		if (isSiblingWeekOneTs) {
			const siblingTs = timesheetPairs[siblingTsIndex];
			return siblingTs.entries.some((entry) => entry.name === TimesheetEntryType.CDO && entry.durations.some((duration) => duration > 0));
		}

		return timesheet.entries.some((entry) => entry.name === TimesheetEntryType.CDO && entry.durations.some((duration) => duration > 0));
	}

	filterTimesheets(): ManagerEmployeeTimesheetView[] {
		const filteredSubmissions = this.employeeTimesheets.filter((s) => {
			if (Array.isArray(this.selectedEmployees)) {
				return this.selectedEmployees.some((emp) => emp.employeeEmail === s.employeeEmail);
			} else {
				return HelperFunctions.compareEmail(this.selectedEmployees || '', s.employeeEmail);
			}
		});

		// approvals
		if (this.isApprovals) {
			const filtered: ManagerEmployeeTimesheetView[] = [];
			this.employeeTimesheets.forEach((s) => {
				for (const [key, value] of Object.entries(this.selectedEmployees)) {
					const temp = [];

					if ((value as any).employeeEmail === s.employeeEmail) {
						const sdArr = (value as any).startDates;

						for (let i = 0; i < sdArr.length; i++) {
							const t = s.timesheets.filter((ts) => {
								return ts.startDate.getTime() === sdArr[i].getTime();
							});

							if (t.length > 0) {
								temp.push(t[0]);
							}
						}

						const tempEE = Object.assign({}, s, {
							timesheets: temp,
						});

						filtered.push(tempEE);
					}
				}
			});

			this.isShowingMultipleTimesheets = filtered.map((submission) => submission.timesheets).flat().length > 1;
			const byWeek: { startDate: Date; user: string[] }[] = [];
			filtered.forEach((u) => {
				u.timesheets.forEach((t) => {
					const wkExists = byWeek.filter((a) => a.startDate.getTime() === t.startDate.getTime());
					if (wkExists.length > 0) {
						wkExists[0].user.push(u.employeeEmail);
					} else {
						byWeek.push({
							startDate: t.startDate,
							user: [u.employeeEmail],
						});
					}
				});
			});

			this.sortedByWeek = byWeek.sort((x: any, y: any) => x.startDate - y.startDate);
			// console.log(byWeek);
			return filtered;
		}

		// team
		if (this.fromDate) {
			const selectedStartDate = new Date(this.fromDate?.year, this.fromDate?.month - 1, this.fromDate?.day);
			this.teamProfileFiltered = this.teamProfile.filter((profile) =>
				this.employeeTimesheets.some(
					(emp) =>
						emp.employeeEmail === profile.email &&
						emp.timesheets.some((timesheet) => timesheet.startDate.getTime() === selectedStartDate.getTime())
				)
			);

			const filtered = filteredSubmissions.map((submission) => {
				let filteredTimesheets = submission.timesheets.filter((timesheet) => {
					return new Date(timesheet.startDate).getTime() == selectedStartDate.getTime();
				});

				// remove predicted timesheets if not neededf
				const hasSavedOrSubmittedTimesheets = filteredTimesheets.find((timesheet) => timesheet.status !== 'Predicted');
				if (hasSavedOrSubmittedTimesheets) {
					filteredTimesheets = filteredTimesheets.filter((timesheet) => timesheet.status !== 'Predicted');
				}

				if (this.isApprovals) {
					filteredTimesheets = filteredTimesheets.filter((timesheet) => timesheet.status === 'Submitted');
				}

				if (filteredTimesheets.length == 0 && !this.isApprovals) {
					const userTimesheets = this.allUserTimesheets.find(
						(timesheets) =>
							timesheets.employeeNumber === submission.employeeNumber || timesheets.employeeEmail === submission.employeeEmail
					);

					const predictedTimesheet = userTimesheets?.timesheets.find(
						(timesheet) => timesheet.startDate.getTime() === selectedStartDate.getTime()
					);
					return {
						...submission,
						timesheets: predictedTimesheet ? [predictedTimesheet] : [],
					};
				} else {
					return {
						...submission,
						timesheets: filteredTimesheets,
					};
				}
			});

			this.isShowingMultipleTimesheets = filtered.map((submission) => submission.timesheets).flat().length > 1;
			return filtered;
		} else {
			return [];
		}
	}

	shouldDarkenEntryBG(date: NgbDate) {
		const payPeriod = this.payPeriods.findIndex((d) => this.isInPP(date, new Date(d.startDate), new Date(d.endDate)));
		if (payPeriod > -1) {
			return payPeriod % 2 === 0;
		}
		return false;
	}

	isInPP(targetDate: NgbDate, start: Date, end: Date) {
		const ngbStart = new NgbDate(start.getFullYear(), start.getMonth() + 1, start.getDate());
		const ngbEnd = new NgbDate(end.getFullYear(), end.getMonth() + 1, end.getDate());
		if (targetDate.equals(ngbStart) || targetDate.equals(ngbEnd) || (targetDate.after(ngbStart) && targetDate.before(ngbEnd))) {
			return true;
		}
		return false;
	}

	inThisMonth(date: NgbDate, currentMonth: CalendarMonthlyEntry): boolean {
		const thisMonth = currentMonth?.month;
		const thisYear = currentMonth?.year;
		if (thisMonth && date.month === thisMonth + 1 && date.year === thisYear) {
			return true;
		}
		return false;
	}

	isToday(date: NgbDate) {
		const today = new Date();
		if (today.getDate() === date.day && today.getMonth() + 1 === date.month && today.getFullYear() === date.year) {
			return true;
		}

		return false;
	}

	onDateSelect(date: NgbDate) {
		// calculate current week
		const fromDate = new Date(date.year, date.month - 1, date.day);
		const dow = this.getDaysFromSat(fromDate.getDay());
		this.fromDate = this.calendar.getPrev(date, 'd', dow);
		this.toDate = this.calendar.getNext(this.fromDate, 'd', 6);

		this.dpForm.get('weekRange')?.setValue(this.dateToString(this.fromDate, this.toDate));
		// console.log('selected: ', date);
		// console.log(this.fromDate);
		// console.log(this.toDate);
		this.filteredTimesheets = this.filterTimesheets();
		this.updateApproveAllLockStatus();
		this.currentWeekStr = this.dateToString(this.fromDate, this.toDate);

		// set selected week text
		this.dpForm.get('weekRange')?.setValue(this.currentWeekStr);
		const endDate = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
		this.deadlineDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() - 1);
		this.updateStatus();
		this.teamForm.reset();

		const thisWeekTs = this.timesheets.find((t) => HelperFunctions.getDateIsWithinBounds(t.startDate, t.endDate, fromDate))!;
		this.currentWeek = {
			startDate: new Date(thisWeekTs.startDate),
			endDate: new Date(thisWeekTs.endDate),
		};

		this.payperiodWeek = HelperFunctions.getTimesheetPayPeriodInfo(thisWeekTs, this.payPeriods);
	}

	isRange(date: NgbDate) {
		return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date);
	}

	isInside(date: NgbDate) {
		return date.after(this.fromDate) && date.before(this.toDate);
	}

	getDaysFromSat(dow: number): number {
		let days = 0;
		switch (dow) {
			case 0: // sunday
				days = 1;
				break;
			case 1: // monday
				days = 2;
				break;
			case 2:
				days = 3;
				break;
			case 3:
				days = 4;
				break;
			case 4:
				days = 5;
				break;
			case 5:
				days = 6;
				break;
			case 6:
				days = 0;
				break;
		}
		// console.log('from sat: ', days)
		return days;
	}

	dateToString(fromDate: NgbDate, toDate: NgbDate): string {
		if (fromDate.year === toDate.year) {
			if (fromDate.month === toDate.month) {
				const mon = this.i18n.getMonthFullName(fromDate.month);
				return `${mon} ${fromDate.day} - ${toDate.day}, ${fromDate.year}`;
			} else {
				const fromMon = this.i18n.getMonthFullName(fromDate.month);
				const toMon = this.i18n.getMonthFullName(toDate.month);
				return `${fromMon} ${fromDate.day} - ${toMon} ${toDate.day}, ${fromDate.year}`;
			}
		} else {
			const fromMon = this.i18n.getMonthFullName(fromDate.month);
			const toMon = this.i18n.getMonthFullName(toDate.month);
			return `${fromMon} ${fromDate.day}, ${fromDate.year} - ${toMon} ${toDate.day}, ${toDate.year}`;
		}
	}

	approveTimesheet(timesheetInfo: ManagerEmployeeTimesheetView, timesheet: Timesheet) {
		if (timesheet.status !== 'Predicted') {
			const submission: TimesheetApprovalSubmission[] = [
				{
					employeeNumber: timesheetInfo.employeeNumber,
					timesheetStartDates: [timesheet.startDate],
					isEdit: false,
				},
			];
			this.store.dispatch(ApproveTimesheets({ submissions: submission, weekRange: HelperFunctions.generateWeekRangeString(timesheet, false) }));
		} else {
			const newTimesheet: PostTimesheet = {
				action: 'approve',
				employeeNumber: timesheetInfo.employeeNumber.toString(),
				payPeriod: timesheet.payPeriod,
				timesheetMetadata: JSON.stringify(timesheet.metadata),
				entryData: JSON.stringify(timesheet.entries),
			};

			const startDate = timesheet.startDate;
			const year = startDate.getFullYear();
			const month = HelperFunctions.convertSingleConstToDoubleDigitStr(startDate.getMonth() + 1);
			const day = HelperFunctions.convertSingleConstToDoubleDigitStr(startDate.getDate());

			const startDateString = `${year}${month}${day}`;

			this.store.dispatch(
				SubmitTimesheet({
					startDate: startDateString,
					timesheet: newTimesheet,
					weekRange: HelperFunctions.generateWeekRangeString(timesheet, false),
				})
			);
		}

		this.filterOutEmployeesApproved(timesheetInfo.employeeNumber, timesheet.startDate);
		this.updateStatus();
	}

	filterOutEmployeesApproved(employeeNumber: string, timesheetStartDate: Date) {
		if (Array.isArray(this.selectedEmployees)) {
			const indexEmployee = this.selectedEmployees.findIndex((emp: any) => this.getEmployeeNumber(emp.employeeEmail) === employeeNumber);

			if (this.selectedEmployees[indexEmployee].startDates.length === 1) {
				this.selectedEmployees = this.selectedEmployees.filter(
					(emp: any) => emp.employeeEmail !== this.selectedEmployees[indexEmployee].employeeEmail
				);
			} else {
				this.selectedEmployees[indexEmployee].startDates = this.selectedEmployees[indexEmployee].startDates.filter(
					(startDate: Date) => startDate.getTime() !== timesheetStartDate.getTime()
				);
			}
		}

		this.filteredTimesheets = this.filterTimesheets();
		this.updateApproveAllLockStatus();
	}

	updateApprovalLockStatus(lockStatus: boolean, timesheet: Timesheet) {
		if (lockStatus) {
			this.approvalLockedTimesheets.push(timesheet);
		}
	}

	getIsTimesheetAllowedToApprove = (timesheet: Timesheet) => {
		// Check if the user is added to the list of users we also manage. If they are, then they are approvable
		const timesheetUserId = timesheet.userId;
		const timekeeperIsUserManager = this.managerUsers.some((mp: ManageProfile) => mp.user.id === timesheetUserId);
		return timekeeperIsUserManager;
	};

	getIsTimesheetApprovalLocked = (timesheet: Timesheet) => {
		const isApprovalLockedTimesheet = this.approvalLockedTimesheets.includes(timesheet);
		if (!this.timekeeperView) return isApprovalLockedTimesheet;
		return isApprovalLockedTimesheet || !this.getIsTimesheetAllowedToApprove(timesheet);
	};

	updateApproveAllLockStatus() {
		const timesheets = this.filteredTimesheets.flatMap((fts) => fts.timesheets);
		let needsLocking = false;

		timesheets.forEach((ts) => {
			if (this.approvalLockedTimesheets.includes(ts)) {
				needsLocking = true;
			}
		});

		this.bulkApproveHasInvalidTimesheets = needsLocking;
	}

	prepApproveTimesheet(email: string, timesheet: Timesheet) {
		const empNum = this.getEmployeeNumber(email);
		const tsInfo = { employeeNumber: empNum } as unknown as ManagerEmployeeTimesheetView;
		this.approveTimesheet(tsInfo, timesheet);
	}

	// bulk approval
	approveTimesheets() {
		const timesheetApprovalSubmissions: TimesheetApprovalSubmission[] = [];

		for (const submission of this.filteredTimesheets) {
			// approve existing saved/submitted timesheets
			const savedAndSubmittedTimesheets = submission.timesheets.filter(
				(timesheet) => (timesheet.status === 'Saved' || timesheet.status === 'Submitted') && !this.getIsTimesheetApprovalLocked(timesheet)
			);

			const savedAndSubmittedStartDates = savedAndSubmittedTimesheets.map((timesheet) => timesheet.startDate);
			if (savedAndSubmittedStartDates.length) {
				timesheetApprovalSubmissions.push({
					employeeNumber: submission.employeeNumber,
					timesheetStartDates: savedAndSubmittedStartDates,
					isEdit: false,
				});
			}
		}

		if (timesheetApprovalSubmissions.length > 0) {
			this.store.dispatch(ApproveTimesheets({ submissions: timesheetApprovalSubmissions })); // if we want to add back in weekrange later: weekRange: HelperFunctions.generateWeekRangeString(timesheet, false)

			timesheetApprovalSubmissions.forEach((timesheet) => {
				timesheet.timesheetStartDates.forEach((startDate) => {
					this.filterOutEmployeesApproved(timesheet.employeeNumber, startDate);
				});
			});

			for (const submission of this.filteredTimesheets) {
				const predictedTimesheets = submission.timesheets.filter((timesheet) => timesheet.status === 'Predicted');

				for (const timesheet of predictedTimesheets) {
					const newTimesheet: PostTimesheet = {
						action: 'approve',
						employeeNumber: submission.employeeNumber.toString(),
						payPeriod: timesheet.payPeriod,
						timesheetMetadata: JSON.stringify(timesheet.metadata),
						entryData: JSON.stringify(timesheet.entries),
					};

					const startDate = timesheet.startDate;
					const year = startDate.getFullYear();
					const month = HelperFunctions.convertSingleConstToDoubleDigitStr(startDate.getMonth() + 1);
					const day = HelperFunctions.convertSingleConstToDoubleDigitStr(startDate.getDate());

					const startDateString = `${year}${month}${day}`;
					this.store.dispatch(SubmitTimesheet({ startDate: startDateString, timesheet: newTimesheet }));

					this.filterOutEmployeesApproved(submission.employeeNumber, startDate);
				}
			}
			this.updateStatus();
		}

		if (this.bulkApproveHasInvalidTimesheets) {
			const notification: UserNotification = {
				type: NotificationStates.Warning,
				title: 'Timesheet(s) approval ignored',
				message:
					'You have one or more invalid timesheets present within the approval queue that were ignored during approvals. Please correct them and try again.',
			};

			this.store.dispatch(ToastUserNotification({ notification }));
		}
	}

	getRelativeConfiguration(timesheet: Timesheet): Configuration {
		let configurationsToCompare: Configuration[] = [];
		const selectedEmployeeCmp = typeof this.selectedEmployees === 'string' ? this.selectedEmployees : '';

		[
			...this.profile.manage,
			...this.profile.managedGoneFromDNV,
			...this.profile.delegated,
			...this.profile.timekeeperDelegated,
			...this.profile.timekeeperManagedUsers,
		].forEach((userEmployee) => {
			if (userEmployee.user.id === timesheet.userId || userEmployee.user.email === selectedEmployeeCmp) {
				configurationsToCompare = userEmployee.configurations ?? blankConfiguration;
			}
		});

		return HelperFunctions.getConfigurationOnDate(configurationsToCompare, timesheet.startDate);
	}

	onChkboxChange(evt: any, i?: number): void {
		if (this.isApprovals) {
			// approvals
			const user = this.emailDateMap[i!];
			if (evt.target?.checked) {
				const ee = this.selectedEmployees.filter((e: { employeeEmail: string }) => e.employeeEmail === user.email);
				if (ee.length > 0) {
					ee[0].startDates.push(user.startDate);
				} else {
					this.selectedEmployees.push({ employeeEmail: user.email, startDates: [user.startDate] });
				}

				this.currentSelectedConfigurations = (this.profile.manage?.find((em) => HelperFunctions.compareEmail(em.user.email, user.email))
					?.configurations ||
					this.profile.delegated?.find((em) => HelperFunctions.compareEmail(em.user.email, user.email))?.configurations) ?? [
					blankConfiguration,
				];

				// this.selectedUserConfiguration = HelperFunctions.getCurrentConfiguration(currentSelectedConfigurations);
			} else {
				const ee = this.selectedEmployees.filter((e: { employeeEmail: string }) => e.employeeEmail === user.email);
				if (ee.length > 0) {
					const i = ee[0].startDates.findIndex((e: { getTime: () => number }) => e.getTime() === user.startDate.getTime());
					if (i > -1) {
						ee[0].startDates.splice(i, 1);
					}
				}
				// remove email too if no startDates
				const noStartDate = this.selectedEmployees.findIndex((e: { startDates: string[] }) => e.startDates.length === 0);
				if (noStartDate > -1) {
					this.selectedEmployees.splice(noStartDate, 1);
				}
			}
		}

		this.quickSelect = '';
		this.filteredTimesheets = this.filterTimesheets();
		this.updateApproveAllLockStatus();
	}

	toggleAll(val: boolean): void {
		if (this.isApprovals)
			this.appArr.controls.forEach((fc) => {
				fc.get('chkbox')?.setValue(val);
			});

		if (val === false) {
			this.selectedEmployees = [];
			this.quickSelect = 'none';
		} else {
			for (const [key, value] of Object.entries(this.emailDateMap)) {
				this.addRemoveApprovalUsers(Number(key));
			}
			this.quickSelect = 'all';
		}

		this.filteredTimesheets = this.filterTimesheets();
		this.updateApproveAllLockStatus();
	}

	setStatus(email: string, status: string) {
		const em = this.teamProfile.findIndex((t) => HelperFunctions.compareEmail(t.email, email));
		if (em > -1) {
			const cloneObj = Object.assign({}, this.teamProfile[em]);
			cloneObj.status = status.toLowerCase();
			this.teamProfile = [...this.teamProfile.slice(0, em), cloneObj, ...this.teamProfile.slice(em + 1)];
		}
	}

	// week changed, update this.teamProfile.status
	updateStatus() {
		if (!this.isApprovals) this.selectedEmployees = [];

		for (const [index, em] of this.employeeTimesheets.entries()) {
			const wk = em.timesheets.filter((t) => {
				// console.log('update status: ', em);
				const sd = new Date(t.startDate);
				const ed = new Date(t.endDate);
				const ngbStart = this.dateToNgbDate(sd);
				const ngbEnd = this.dateToNgbDate(ed);
				if (ngbStart.equals(this.fromDate) && ngbEnd.equals(this.toDate)) {
					return t;
				}
				return null;
			});
			if (wk.length > 0) {
				const isTimesheetInvalid = this.getTimesheetIsInvalid(wk[0]);
				this.setStatus(em.employeeEmail, isTimesheetInvalid ? 'invalid' : wk[0].status);
			} else {
				this.setStatus(em.employeeEmail, 'saved');
			}
		}

		this.filteredTimesheets = this.filterTimesheets();
		this.updateApproveAllLockStatus();
		this.updateStatusCounts();
	}

	updateStatusCounts() {
		this.statusCount = {
			submitted: 0,
			invalid: 0,
			pending: 0,
			approved: 0,
			jde: 0,
		};

		this.teamProfile.forEach((t) => {
			// only update the count if the user is present at the district currently
			if (!this.profile.managedGoneFromDNV.some((profile) => profile.user.email.toLowerCase() === t.email.toLowerCase())) {
				switch (t.status) {
					case 'submitted':
						this.statusCount.submitted++;
						break;
					case 'invalid':
						this.statusCount.invalid++;
						break;
					case 'predicted':
					case 'saved':
						this.statusCount.pending++;
						break;

					case 'jde':
						this.statusCount.jde++;
						break;
					case 'approved':
						this.statusCount.approved++;
						break;
				}
			}
		});
	}

	getStatusText(status: string | undefined): string {
		switch (status?.toLowerCase()) {
			case 'submitted':
				return 'This timesheet is pending your approval.';
			case 'invalid':
				return 'This timesheet is invalid and requires review.';
			case 'approved':
				return 'This timesheet has been approved.';
			case 'jde':
				return 'This timesheet has been sent to JDE.';
			default:
				return "This timesheet hasn't been submitted yet";
		}
	}

	dateToNgbDate(convertDate: Date): NgbDate {
		return new NgbDate(convertDate.getFullYear(), convertDate.getMonth() + 1, convertDate.getDate());
	}

	getMemberProfile(email: string) {
		const member = this.teamProfile.filter((t) => HelperFunctions.compareEmail(t.email, email));
		return member.length > 0 ? member[0] : null;
	}

	getMemberProfilePic(email: string): SafeUrl | null {
		const member = this.getMemberProfile(email);
		if (member) {
			return member.profilePic;
		}
		return null;
	}

	getApprovalsMemberStatus(email: string, startDate: Date) {
		const employee = this.employeeTimesheets.find((e) => e.employeeEmail === email)!;
		if (!employee) return '';

		const timesheet = employee.timesheets.find((t) => t.startDate.getTime() === startDate.getTime())!;
		const isTimesheetInvalid = this.getTimesheetIsInvalid(timesheet);
		return isTimesheetInvalid ? 'invalid' : 'submitted';
	}

	getCtrlIdx(key: number, email: string): any {
		const user = this.approvalWeeks[key].filter((u) => u.email === email);
		let result = '';
		for (const [key, value] of Object.entries(this.emailDateMap)) {
			if (value.email === email && value.week === user[0].week) {
				result = key;
			}
		}
		return result;
	}

	showWeekTitle(i: number): boolean {
		let result = true;
		if (i > 0) {
			if (this.emailDateMap[i].week === this.emailDateMap[i - 1].week) {
				result = false;
			}
		}
		return result;
	}

	isSelected(i: number): boolean {
		let result = false;
		if (this.isApprovals) {
			if (this.appArr.at(i).get('chkbox')?.value === true) {
				result = true;
			}
		}

		return result;
	}

	selectCurrentWeek(): void {
		this.toggleAll(false); // unselect all boxes before selecting just the current week
		this.quickSelect = 'week';
		const idx = [];
		for (const [key, value] of Object.entries(this.emailDateMap)) {
			if (value.week === this.currentWeekStr) {
				idx.push(Number(key));
			}
		}
		idx.forEach((i) => {
			this.appArr.at(i).get('chkbox')?.setValue(true);
			this.addRemoveApprovalUsers(i);
		});
		this.filteredTimesheets = this.filterTimesheets();
		this.updateApproveAllLockStatus();
	}

	addRemoveApprovalUsers(idx: number): void {
		const user = this.emailDateMap[idx];
		const ee = this.selectedEmployees.filter((e: { employeeEmail: string }) => e.employeeEmail === user.email);
		if (ee.length > 0) {
			let inArr = false;
			for (let x = 0; x < ee[0].startDates.length; x++) {
				if (ee[0].startDates[x].getTime() === user.startDate.getTime()) {
					inArr = true;
					break;
				}
			}
			if (!inArr) {
				ee[0].startDates.push(user.startDate);
			}
		} else {
			this.selectedEmployees.push({ employeeEmail: user.email, startDates: [user.startDate] });
		}
	}

	getTeamMemberName(email: string): string {
		if (this.timekeeperView) {
			const user = this.allUserTimesheets.find((timesheet) => HelperFunctions.compareEmail(timesheet.employeeEmail, email));
			if (user) {
				return user.employeeFirstName + ' ' + user.employeeLastName;
			}
		} else {
			const managedUsers = [...this.profile.manage, ...this.profile.delegated, ...this.profile.managedGoneFromDNV];
			const user = managedUsers.filter((tm) => HelperFunctions.compareEmail(tm.user.email, email));

			if (user && user?.length > 0) {
				return user[0].user.firstName + ' ' + user[0].user.lastName;
			}
		}
		return '';
	}

	getUserIsManagerTeamMember(email: string) {
		const user = this.allManagedUsers.find((u) => HelperFunctions.compareEmail(u.user.email, email));
		const loggedInManager = this.profile.user;
		return user?.user.managerId === loggedInManager.id;
	}

	getUserManager(email: string) {
		const user = this.allManagedUsers.find((u) => HelperFunctions.compareEmail(u.user.email, email));
		const manager = this.profile.allUsers.find((u) => u.id === user?.user.managerId);
		return `${manager?.firstName} ${manager?.lastName}`;
	}

	getTimesheetPayPeriodInfo(timesheet: Timesheet) {
		return HelperFunctions.getTimesheetPayPeriodInfo(timesheet, this.payPeriods);
	}

	getUserCdo(submission: ManagerEmployeeTimesheetView | null, timesheet: Timesheet, userEmail = '') {
		let activeConfig: Configuration;

		if (submission) {
			activeConfig = HelperFunctions.getConfigurationOnDate(submission.configurations, timesheet.startDate);
		} else {
			const user = this.allManagedUsers.find(
				(u) => u.user.upn.toLowerCase() === userEmail.toLowerCase() || u.user.email.toLowerCase() === userEmail.toLowerCase()
			)!;

			activeConfig = HelperFunctions.getConfigurationOnDate(user.configurations, timesheet.startDate);
		}

		if (!activeConfig.cdo) {
			return 'Not enrolled';
		}

		const cdoDay = activeConfig.cdoDay;
		const isWeek1 = cdoDay <= 7;
		const dayOfWeekIndex = isWeek1 ? HelperFunctions.getDayOfWeekFromNumber(cdoDay) : HelperFunctions.getDayOfWeekFromNumber(cdoDay - 7);

		const dayOfWeek = HelperFunctions.convertNumberToDayOfWeek(dayOfWeekIndex);
		return `Week ${isWeek1 ? 1 : 2} ${dayOfWeek}`;
	}

	getEmployeeNumber(email: string): string {
		const user = [
			...this.profile.manage?.filter((tm) => HelperFunctions.compareEmail(tm.user.email, email)),
			...this.profile.delegated?.filter((tm) => HelperFunctions.compareEmail(tm.user.email, email)),
		];

		if (user && user?.length > 0) {
			return user[0].user.employeeNumber;
		}
		return '';
	}

	getTimesheetByStartDate(startDate: Date, email: string): any {
		const user = this.filteredTimesheets.filter((u) => u.employeeEmail === email);
		if (user.length > 0) {
			return user[0].timesheets.filter((t) => t.startDate.getTime() === startDate.getTime())[0];
		}
	}

	scrollToTop() {
		this.scroll.scrollToPosition([0, 0]);
	}

	getTimeEntryTypes = (timesheet: Timesheet) => HelperFunctions.filterTimeEntryTypes(this.getRelativeConfiguration(timesheet));

	convertTimeEntryCodeToEntryTextMap(timeEntryTypes: TimesheetExceptionType[]) {
		return timeEntryTypes.reduce((previousValue: { [id: string]: string }, currentValue: TimesheetExceptionType) => {
			previousValue[currentValue.code] = currentValue.entryText;
			return previousValue;
		}, {});
	}

	getTimesheetIsInvalid(timesheet: Timesheet) {
		const timesheetEntryTypes = this.getTimeEntryTypes(timesheet);
		const entryTypeToEntryTextMap = this.convertTimeEntryCodeToEntryTextMap(timesheetEntryTypes);

		let entryHasError = false;
		timesheet.entries.forEach((entry) => {
			const entryText = entryTypeToEntryTextMap[entry.name];
			if (!entryText) {
				entryHasError = true;
			}
		});

		return entryHasError;
	}

	openTimesheetEditModal(employeeEmail: string, currentTimesheet: Timesheet) {
		const ngbModalOptions: NgbModalOptions = {
			keyboard: false,
			centered: true,
			scrollable: true,
			windowClass: 'edit-modal',
		};

		const entryConfiguration = this.getRelativeConfiguration(currentTimesheet);

		const modalRef = this.modalService.open(TimesheetComponent, ngbModalOptions);
		modalRef.componentInstance.currentEmployeeEmail = employeeEmail;
		modalRef.componentInstance.currentConfiguration = entryConfiguration;
		modalRef.componentInstance.timeEntryTypes = HelperFunctions.filterTimeEntryTypes(entryConfiguration);
		modalRef.componentInstance.isEditingEmployeeTimesheet = true;
		modalRef.componentInstance.selectedTimesheet = currentTimesheet;
		modalRef.componentInstance.weekOneTsHasUsedCdo = this.getWeekOneTsHasUsedCdo(currentTimesheet, employeeEmail);
		modalRef.result.then((result: any) => {
			if (result && result.employeeNumber && result.startDate) {
				this.filterOutEmployeesApproved(result.employeeNumber, result.startDate);
			}
		});
	}

	isOverDue(): boolean {
		const today = new Date();
		return this.deadlineDate < today;
	}

	onRdoClick(email: string): void {
		if (this.selectedEmployees !== email) {
			this.selectedEmployees = email;
			this.filteredTimesheets = this.filterTimesheets();
			this.updateApproveAllLockStatus();
			const user = this.profile.manage.find((member) => member.user.email === email);
			if (user) {
				this.selectedUserConfiguration = HelperFunctions.getCurrentConfiguration(user.configurations);
			}
		}
	}

	showTeamMembers(): boolean {
		return this.profile.manage.length > 0 || this.profile.delegated.length > 0 || this.teamProfile.length > 0;
	}

	filterByStatus = (status: string) => (this.filterBy = this.filterBy === status ? '' : status);
	getIsFilterToggled = (status: string) => this.filterBy === status;

	filterAction(status: string): boolean {
		if (this.filterBy.length > 0) {
			return this.filterBy.indexOf(status) === -1;
		}
		return false;
	}
}
